// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"65d7aca6","371":"5764d2eb","453":"51b20bab","626":"9a8ddb32"}[chunkId] + ".chunk.js";
};